<template>
  <div class="chart-box">
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    list: {
      handler(newData) {
        let data = newData.map((p) => {
          return [
            p.userName,
            p.bedName,
            this.warningTypeMap.get(p.type),
            this.levelMap.get(p.level || 1),
            p.creatorTime,
          ];
        });
        this.config = {
          data: data,
          header: ["告警来源", "床号", "告警类型", "告警级别", "告警时间"],
          headerBGC: "transparent",
          index: true,
          indexHeader: "序号",
          columnWidth: [50, 80, 60, 80, 80],
        };
      },
    },
  },
  data() {
    return {
      config: {},
      levelMap: new Map([
        [1, "提醒通知"],
        [2, "故障通知"],
        [3, "严重警告"],
      ]),
      warningTypeMap: new Map([
        [101, "晚起"],
        [102, "心率过高"],
        [103, "心率过低"],
        [105, "SOS"],
        [106, "用餐次数少于日常"],
        [107, "血氧过低"],
        [108, "血氧过高"],
        [109, "体温过高"],
        [110, "体温过低"],
        [111, "血压过高"],
        [112, "血压过低"],
        [113, "呼吸率过高"],
        [114, "呼吸率过低"],
        [115, "血糖过高"],
        [116, "血糖过低"],
        [117, "离床"],
      ]),
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.chart-box {
  margin-top: 20px;
  width: 100%;
  height: 320px;
}
</style>
